import React from 'react';
import styled from 'styled-components';
import ReactLoading from 'react-loading';

import { themes } from 'kb-shared';
import { typography } from '../../styled';
const { colors } = themes;
const {
  sans: {
    copy: { Medium }
  }
} = typography;

type Props = {
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  text: string;
};

const Container = styled.button`
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  width: 247px;
  border-radius: 27.5px;
  border: solid ${colors.KBTwilightDark} 1px;
  opacity: ${({ disabled }) => (disabled ? '0.8' : '1.0')};
  transition: box-shadow 200ms;

  :hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    opacity: 0.8;
  }
  :focus {
    outline: 0;
  }
  text-transform: uppercase;
`;

const Text = styled(Medium)`
  color: ${colors.KBNight};
  margin: 0;
`;

const Button = (props: Props) => {
  const { disabled, loading, onClick, text } = props;
  return (
    <Container onClick={onClick} disabled={disabled} color={colors.KBTwilightDark}>
      {loading ? (
        <ReactLoading type="spin" height={20} width={20} color={colors.KBTwilightDark} />
      ) : (
        <Text>{text}</Text>
      )}
    </Container>
  );
};

export default Button;
